var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSkills(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "contenitore",
    width: 70,
    height: 70,
    transform: "translate(285 633)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 1,
    opacity: 0
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "competenze_illustrazione",
    "data-name": "competenze illustrazione",
    transform: "translate(-104 -299)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppo_di_maschere_29",
    "data-name": "Gruppo di maschere 29",
    transform: "translate(-181 -334)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3184",
    "data-name": "Raggruppa 3184"
  }, /*#__PURE__*/React.createElement("path", {
    id: "fondo",
    d: "M25.57,74.016C2.232,86.383-.045,34.5,3.708,27.4c12.148-16.948,24.552,1.447,33.886-6.18C51.945,9.483,67.032,9.035,70.109,23.826s-.2,48.362-20.981,44.858C34.375,66.2,25.57,74.016,25.57,74.016Z",
    transform: "translate(278.439 629.598) rotate(-8)",
    fill: "#dedbdb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "base",
    d: "M297.906,717.831H228.094a.094.094,0,0,1,0-.188h69.812a.094.094,0,0,1,0,.188Z",
    transform: "translate(57 -25.643)",
    fill: "#ccc",
    stroke: "#ccc",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "libro",
    transform: "translate(-2 5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_1008",
    "data-name": "Tracciato 1008",
    d: "M347.643,584.643v12.745H315.712a6.376,6.376,0,1,1,0-12.745Z",
    transform: "translate(-16.498 88.76)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_1009",
    "data-name": "Tracciato 1009",
    d: "M342.114,594.584a.49.49,0,0,1-.49.49H308.83a6.716,6.716,0,1,1,0-13.431h32.794a.49.49,0,1,1,0,.98H308.83a5.735,5.735,0,0,0,0,11.471h32.794A.49.49,0,0,1,342.114,594.584Z",
    transform: "translate(-10.184 91.467)",
    fill: "#03518c",
    stroke: "#03518c",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_1010",
    "data-name": "Tracciato 1010",
    d: "M385.526,612.839H351.212a.1.1,0,0,1,0-.2h34.314a.1.1,0,1,1,0,.2Z",
    transform: "translate(-54.381 63.505)",
    fill: "#ccc",
    stroke: "#ccc",
    strokeWidth: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_1011",
    "data-name": "Tracciato 1011",
    d: "M385.526,636.839H351.212a.1.1,0,1,1,0-.2h34.314a.1.1,0,1,1,0,.2Z",
    transform: "translate(-54.381 41.858)",
    fill: "#ccc",
    stroke: "#ccc",
    strokeWidth: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_1012",
    "data-name": "Tracciato 1012",
    d: "M385.526,660.839H351.212a.1.1,0,0,1,0-.2h34.314a.1.1,0,1,1,0,.2Z",
    transform: "translate(-54.381 20.211)",
    fill: "#ccc",
    stroke: "#ccc",
    strokeWidth: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_1013",
    "data-name": "Tracciato 1013",
    d: "M385.526,684.839H351.212a.1.1,0,0,1,0-.2h34.314a.1.1,0,1,1,0,.2Z",
    transform: "translate(-54.381 -1.437)",
    fill: "#ccc",
    stroke: "#ccc",
    strokeWidth: 0.4
  })), /*#__PURE__*/React.createElement("g", {
    id: "libro-2",
    "data-name": "libro",
    transform: "translate(572.302 -32.859) rotate(43)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_1014",
    "data-name": "Tracciato 1014",
    d: "M343.17,584.643v11.266H314.946a5.636,5.636,0,1,1,0-11.266Z",
    transform: "translate(-16.577 88.726)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_1015",
    "data-name": "Tracciato 1015",
    d: "M337.471,593.082a.433.433,0,0,1-.433.433H308.05a5.936,5.936,0,1,1,0-11.872h28.987a.433.433,0,1,1,0,.867H308.05a5.07,5.07,0,0,0,0,10.139h28.987A.433.433,0,0,1,337.471,593.082Z",
    transform: "translate(-10.184 91.467)",
    fill: "#b8b8b8",
    stroke: "#b8b8b8",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_1016",
    "data-name": "Tracciato 1016",
    d: "M381.531,612.816H351.2a.087.087,0,1,1,0-.173h30.33a.087.087,0,1,1,0,.173Z",
    transform: "translate(-54.938 63.153)",
    fill: "#ccc",
    stroke: "#ccc",
    strokeWidth: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_1017",
    "data-name": "Tracciato 1017",
    d: "M381.531,636.816H351.2a.087.087,0,0,1,0-.173h30.33a.087.087,0,1,1,0,.173Z",
    transform: "translate(-54.938 41.232)",
    fill: "#ccc",
    stroke: "#ccc",
    strokeWidth: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_1018",
    "data-name": "Tracciato 1018",
    d: "M381.531,660.816H351.2a.087.087,0,1,1,0-.173h30.33a.087.087,0,1,1,0,.173Z",
    transform: "translate(-54.938 19.312)",
    fill: "#ccc",
    stroke: "#ccc",
    strokeWidth: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_1019",
    "data-name": "Tracciato 1019",
    d: "M381.531,684.816H351.2a.087.087,0,0,1,0-.173h30.33a.087.087,0,1,1,0,.173Z",
    transform: "translate(-54.938 -2.609)",
    fill: "#ccc",
    stroke: "#ccc",
    strokeWidth: 0.4
  })), /*#__PURE__*/React.createElement("g", {
    id: "cappello",
    transform: "matrix(0.94, -0.342, 0.342, 0.94, 16479.922, -25011.756)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_1004",
    "data-name": "Tracciato 1004",
    d: "M351.864,245.544a35.4,35.4,0,0,1-14.351-3.143,1.516,1.516,0,0,1-.9-1.391V228.668a1.527,1.527,0,0,1,1.525-1.525h27.45a1.527,1.527,0,0,1,1.525,1.525V241.01a1.516,1.516,0,0,1-.9,1.391h0A35.4,35.4,0,0,1,351.864,245.544Z",
    transform: "translate(-24323.082 18352.998)",
    fill: "#03518c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_1005",
    "data-name": "Tracciato 1005",
    d: "M336.164,211.962a1.526,1.526,0,0,1-.593-.119L313.8,202.659a1.525,1.525,0,0,1,.052-2.831l21.768-8.258a1.52,1.52,0,0,1,1.088,0l21.476,8.258a1.525,1.525,0,0,1,.052,2.826l-21.476,9.184A1.527,1.527,0,0,1,336.164,211.962Z",
    transform: "translate(-24307.387 18376.574)",
    fill: "#03518c"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellisse_80",
    "data-name": "Ellisse 80",
    cx: 2.033,
    cy: 2.033,
    r: 2.033,
    transform: "translate(-23985.963 18592.17)",
    stroke: "#000",
    strokeWidth: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_1006",
    "data-name": "Tracciato 1006",
    d: "M358.919,219.525l-21.477,9.184a1.355,1.355,0,0,1-1.06,0l-21.767-9.183a1.33,1.33,0,0,1-.648-.57,1.354,1.354,0,0,0,.648,1.925l21.767,9.184a1.355,1.355,0,0,0,1.06,0l21.477-9.184a1.355,1.355,0,0,0,.642-1.923A1.331,1.331,0,0,1,358.919,219.525Z",
    transform: "translate(-24307.99 18358.402)",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_1007",
    "data-name": "Tracciato 1007",
    d: "M343.957,236.571a.339.339,0,0,0,.339-.339v-11.34l11.177-4.072a.339.339,0,0,0,.01-.678l-11.177,4.072a.665.665,0,0,0-.486.2.673.673,0,0,0-.2.483v11.34A.339.339,0,0,0,343.957,236.571Z",
    transform: "translate(-24327.713 18357.625)",
    stroke: "#000",
    strokeWidth: 0.4
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSkills);
export default __webpack_public_path__ + "static/media/skills.c088d7ccbe113a23ee5ea6b00a33b413.svg";
export { ForwardRef as ReactComponent };